import React, { useState } from "react";
import { Cloud, Globe, Server, PiggyBank, Zap, Rocket, Flame } from "lucide-react";

const ICONS = { Cloud, Globe, Server, PiggyBank, Zap, Rocket, Flame };

/**
 * Renders a registrar logo with two-tier fallback chain:
 *   Clearbit Logo API → Google favicon → Lucide icon.
 * Both image sources are free, no key required.
 */
export default function RegistrarLogo({ registrar, size = 28 }) {
  const [stage, setStage] = useState(0); // 0 = clearbit, 1 = google favicon, 2 = lucide
  const Icon = ICONS[registrar.icon] || Globe;
  const dom = registrar.logo_domain;

  if (!dom) {
    return <Icon className="text-zinc-700" style={{ width: size, height: size }} />;
  }

  if (stage === 0) {
    return (
      <img
        src={`https://logo.clearbit.com/${dom}?size=64`}
        alt={`${registrar.name} logo`}
        width={size}
        height={size}
        loading="lazy"
        className="rounded-md object-contain"
        onError={() => setStage(1)}
      />
    );
  }
  if (stage === 1) {
    return (
      <img
        src={`https://www.google.com/s2/favicons?sz=64&domain=${dom}`}
        alt={`${registrar.name} logo`}
        width={size}
        height={size}
        loading="lazy"
        className="rounded-md object-contain"
        onError={() => setStage(2)}
      />
    );
  }
  return <Icon className="text-zinc-700" style={{ width: size, height: size }} />;
}
